import React from 'react';
import MUIPopper from '@mui/material/Popper';

const Popper = props => <MUIPopper placement="bottom-start" sx={{ zIndex: 1300 }} {...props} />;

export default Popper;
